import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { UiLicenseUsageSubtitleComponent } from '@components/shared/license/ui-license-usage-subtitle.component';
import { UiLicenseUsageComponent } from '@components/shared/license/ui-license-usage.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatDividerModule,
        RouterModule,
        TranslateModule,
        MatButtonModule,
    ],
    declarations: [
        UiLicenseUsageSubtitleComponent,
        UiLicenseUsageComponent,
    ],
    exports: [
        UiLicenseUsageComponent,
    ],
})
export class UiLicenseUsageModule { }
